import { stringifyUrl } from "query-string";
import { useEffect, useState } from "react";
import { TxTags } from "../api/type";

// 获取tokens，lps，labels等数据
export const useTxTagsQuery = ({
  chain,
  txhash,
  onSuccess,
}: {
  chain: number;
  txhash?: string;
  onSuccess?: (results: any) => void;
}) => {
  const [data, setData] = useState<TxTags>({});
  const [isLoading, setIsLoading] = useState(false);
  const [params, setParams] = useState<{ txhash: string }>({ txhash: "" });

  const run = (nextParams: { txhash: string }) => {
    setParams({ ...params, ...nextParams });
  };

  useEffect(() => {
    if (txhash) {
      setParams({ ...params, txhash });
    }
    //eslint-disable-next-line
  }, [txhash]);

  useEffect(() => {
    if (params?.txhash?.length <= 0 || !chain) return;

    setIsLoading(true);

    let tagsPromise: any = [];

    params?.txhash?.split(",")?.forEach((tx) => {
      const path = `https://${
        process.env.REACT_APP_ENV === "test" ? "test-" : ""
      }eigentx-related-txs-tags-tepu46la6a-uw.a.run.app`;
      const endpoint = stringifyUrl({ url: path, query: { tx, chain } });

      tagsPromise.push(
        fetch(endpoint).catch((error) => {
          console.log("error", tx, chain);

          // 请求失败了，伪造成功的结果，避免报错
          return Promise.resolve({ json: () => Promise.resolve({}) });
        })
      );
    });

    Promise.all(tagsPromise)
      .then(async (result) => {
        let data = {};
        for (const resultPromise of result) {
          const json = await resultPromise.json();

          data = { ...data, ...json };
        }

        setData(data);

        onSuccess?.({ results: data, params });
      })
      .finally(() => {
        setIsLoading(false);
      });
    //eslint-disable-next-line
  }, [chain, params?.txhash]);

  return {
    data,
    isLoading,
    run,
  };
};
